export default {
    title: 'Obnova lozinke',
    title_submitted: 'Gotovo! Prijavite se za nastavak.',
    title_expired: 'Zahtev je istekao',
    subtitle: 'Unesite lozinku.',
    buttons: {
        go_to_login: 'Idi na prijavu',
    },
    notifications: {
        password_changed: 'Vaša lozinka je promenjena',
        request_expired: 'Vaš zahtev je istekao. Pokušajte ponovo!',
    },
}
